<div *ngIf="loading" class="py-4 text-center">
    <app-loader></app-loader>
</div>

<div *ngIf="!loading" class="d-flex flex-column gap-4">
    <div>
        <h2 class="h4 mb-2">{{ 'eids.title' | translate }}</h2>
        <p class="text-muted mb-0">{{ 'eids.intro' | translate }}</p>
    </div>

    <div class="card p-3" *ngIf="status?.required === false">
        <p class="mb-0">{{ 'eids.not_required' | translate }}</p>
    </div>

    <div class="card p-3">
        <h3 class="h6">{{ 'eids.todo.gsm' | translate }}</h3>
        <p class="mb-2" *ngIf="status?.gsmVerified">{{ 'eids.gsm.verified' | translate }}</p>
        <p class="text-muted mb-2" *ngIf="!status?.profilePhonePresent">{{ 'eids.gsm.missing' | translate }}</p>
        <a class="btn btn-outline-primary" routerLink="/profile/personal-info" *ngIf="!status?.profilePhonePresent">{{ 'eids.gsm.edit_profile' | translate }}</a>
        <p class="text-muted mb-2" *ngIf="status?.profilePhonePresent && !status?.gsmVerified">
            {{ 'eids.gsm.help' | translate }}
            <strong>{{ status?.profilePhoneMasked }}</strong>
        </p>
        <button class="btn btn-primary" type="button" (click)="requestOtp()" [disabled]="requesting" *ngIf="status?.profilePhonePresent && !status?.gsmVerified">
            {{ 'eids.otp.send' | translate }}
        </button>
        <form [formGroup]="codeForm" (ngSubmit)="verifyOtp()" class="d-flex flex-column gap-2 mt-3" *ngIf="status?.profilePhonePresent && !status?.gsmVerified">
            <label class="form-label mb-0" for="eids-code">{{ 'eids.otp.code' | translate }}</label>
            <input id="eids-code" class="form-control" inputmode="numeric" formControlName="code" maxlength="6" autocomplete="one-time-code" />
            <button class="btn btn-outline-primary" type="submit" [disabled]="verifying">{{ 'eids.otp.verify' | translate }}</button>
        </form>
    </div>

    <div class="card p-3">
        <h3 class="h6">{{ 'eids.todo.link' | translate }}</h3>
        <p class="mb-2" *ngIf="status?.linked">{{ 'eids.link.done' | translate }} {{ status?.verifiedName }}</p>
        <p class="text-muted" *ngIf="!status?.linked">{{ 'eids.link.help' | translate }}</p>
        <button class="btn btn-primary" type="button" (click)="startSso()" [disabled]="!status?.gsmVerified || !!status?.linked">
            {{ 'eids.sso.start' | translate }}
        </button>
    </div>
</div>
